// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.server-clock[data-v-06b87eb6] {\n  background-color: #fafafa;\n}\n.clock-time[data-v-06b87eb6] {\n  font-variant-numeric: tabular-nums;\n  font-family: 'Roboto Mono', monospace;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
